export const SET_SUBMIT_SELECTED_OPTION = "SET_SUBMIT_SELECTED_OPTION";

export const setSelectedOption = (option) => {
  return {
    type: SET_SUBMIT_SELECTED_OPTION,
    payload: { option },
  };
};

